import { SortInput } from 'components/Table'
import { DomainSortBy } from './types'

export const DEFAULT_SORT: SortInput<DomainSortBy> = {
  by: 'name',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: DomainSortBy[] = [
  'name',
  'prebidStackEnabled',
  'priceGeniusEnabled',
  'refresherEnabled',
  'unfilledRecoveryEnabled',
  'updatedAt',
  'viewabilityToolsEnabled',
]
